import type { RouteRecordRaw } from 'vue-router'

const creditRoutes: RouteRecordRaw[] = [
  {
    path: 'credits',
    name: 'Credits',
    component: () => import('@/pages/credits/index.vue'),
    meta: { title: '积分管理' },
  },
]

export default creditRoutes
